module.exports = __webpack_public_path__ + "static/media/check.74836e6d.svg";